import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import getProp from "@insite/mobius/utilities/getProp";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: OneTrustButtonLinkStyles;
}

export interface OneTrustButtonLinkStyles {
    button?: ButtonPresentationProps;
}

export const oneTrustButtonLinkStyles: OneTrustButtonLinkStyles = {
    button: {
        typographyProps: {
            size: 11,
            weight: 600,
        },
        css: css`
            &:not(#important) {
                &,
                &:hover {
                    all: unset;
                    display: inline-flex;
                    font-size: 11px;
                    font-weight: 600;
                    cursor: pointer;
                }

                &:focus {
                    outline-offset: 1px;
                    outline-color: ${getProp("theme.focus.color")};
                    outline-style: solid;
                    outline-width: 2px;
                }

                &:after {
                    content: none;
                }
            }
        `,
    },
};

type Props = OwnProps;

const OneTrustButtonLink: React.FC<Props> = ({ extendedStyles }) => {
    const [styles] = useState(() => mergeToNew(oneTrustButtonLinkStyles, extendedStyles));

    return <Button {...styles.button}>{translate("Cookies Settings")}</Button>;
};

const definition: WidgetDefinition = {
    displayName: "OneTrust Button Link",
    group: "Common",
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: OneTrustButtonLink,
    definition,
};

export default widgetModule;
